import React, { FC, useEffect, useRef, useState } from 'react';
import classes from './VisitorsPage.module.scss';
import VisitorsReportTable from '../../../components/Admin/Tables/AnalyticsAndReports/VisitorsReportTable/VisitorsReportsTable';
import HeaderAnalyticsTables from '../../../components/Admin/HeaderAnalyticsAndReports/HeaderAnalyticsTables';
import { useGetVisitorsReport } from '../../../hooks/Admin/AnalyticsAndReportsTables/VisitorsReport/useGetVisitorsReport';
import { currentDate } from '../../../utils/Admin/AnalyticsAndReports/formatAnalyticAndReportsDate';
import { saveAsCSV } from '../../../utils/Admin/AnalyticsAndReports/saveAsCSV';
import { VisitorsHeader } from '../../../types/enums';
import BranchQueueFilter from '../../../components/Admin/BranchQueueFilter/BranchQueueFilter';
import { useAdminQueueIdsFilter } from '../../../hooks/Admin/useAdminQueueIdsFilter';

const tabsList = ['Период'];
const isActiveButtonCSV = true;

const VisitorsReportPage: FC = () => {
  const [activeTab, setActiveTab] = useState(tabsList[0]);
  const [selectedStartDate, setSelectedStartDate] = useState(currentDate);
  const [selectedEndDate, setSelectedEndDate] = useState(currentDate);
  const [filterBranchIds, setFilterBranchIds] = useState<number[]>([]);
  const [filterQueueIds, setFilterQueueIds] = useState<number[]>([]);
  const selectedBranchQueueId = filterQueueIds.length ? filterQueueIds[0] : null;
  const isQueueSelected = selectedBranchQueueId != null;
  const { queueIdsFilter } = useAdminQueueIdsFilter();
  const prevQueueIdRef = useRef<number | null>(null);
  const selectedDate = {
    startDate: selectedStartDate,
    endDate: selectedEndDate,
    branchQueueId: selectedBranchQueueId
  };
  const {
    visitorsReportResp: visitorsReportDate,
    refetchVisitorsReport,
    isLoadingVisitorsReport
  } = useGetVisitorsReport(selectedDate);

  const handleSaveAsCSV = () => saveAsCSV(visitorsReportDate, VisitorsHeader);

  useEffect(() => {
    const prev = prevQueueIdRef.current;
    if (prev !== null && selectedBranchQueueId !== null && prev !== selectedBranchQueueId) {
      setSelectedStartDate(currentDate);
      setSelectedEndDate(currentDate);
    }
    prevQueueIdRef.current = selectedBranchQueueId;
  }, [selectedBranchQueueId]);

  useEffect(() => {
    if (isQueueSelected) {
      refetchVisitorsReport();
    }
  }, [selectedStartDate, selectedEndDate, selectedBranchQueueId]);

  return (
    <div className={classes.container}>
      <HeaderAnalyticsTables
        tabs={tabsList}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleSaveAsCSV={handleSaveAsCSV}
        isActiveButtonCSV={isActiveButtonCSV && isQueueSelected}
        selectedStartDate={selectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedStartDate={setSelectedStartDate}
        setSelectedEndDate={setSelectedEndDate}
        name="Отчет по посетителям"
        filterContent={
          <BranchQueueFilter
            selectedBranchIds={filterBranchIds}
            selectedQueueIds={filterQueueIds}
            onBranchChange={setFilterBranchIds}
            onQueueChange={setFilterQueueIds}
            singleQueue
            queueIdsFilter={queueIdsFilter}
          />
        }
      />

      {!isQueueSelected ? (
        <div className={classes.emptyState}>
          Выберите очередь в фильтре, чтобы отобразить данные
        </div>
      ) : (
        <VisitorsReportTable
          visitorsReportDate={visitorsReportDate}
          isLoadingData={isLoadingVisitorsReport}
        />
      )}
    </div>
  );
};

export default VisitorsReportPage;
